import { Button } from "@dropbox/dig-components/buttons";
import { useMirageAnalyticsContext } from "@mirage/analytics/AnalyticsProvider";
import type { DashExtensionUpsellSurface } from "@mirage/analytics/events/enums/dash_extension_upsell_surface";
import { PAP_Click_DashOnboardingDownloadExtensionButton } from "@mirage/analytics/events/types/click_dash_onboarding_download_extension_button";
import useAvailableExtensions from "@mirage/settings/utils/useAvailableExtensions";
import { SvgForCurrentBrowserWebExtension } from "@mirage/shared/util/webExtensionsHelpers";
import i18n from "@mirage/translations";
import { useCallback } from "react";
import styles from "./ExtensionUpsellButton.module.css";

type Props = {
  surface?: DashExtensionUpsellSurface;
  onOpenExtensionLinkForCurrentBrowser?: () => void;
  uxaElementId: string;
};

export const ExtensionUpsellButton = ({
  surface,
  onOpenExtensionLinkForCurrentBrowser,
  uxaElementId,
}: Props) => {
  const { openExtensionUrl } = useAvailableExtensions();
  const { reportPapEvent } = useMirageAnalyticsContext();

  const handleClick = useCallback(() => {
    reportPapEvent(
      PAP_Click_DashOnboardingDownloadExtensionButton({
        featureLine: "onboarding",
        dashExtensionUpsellSurface: surface,
      }),
    );
    openExtensionUrl();
    onOpenExtensionLinkForCurrentBrowser?.();
  }, [
    onOpenExtensionLinkForCurrentBrowser,
    openExtensionUrl,
    reportPapEvent,
    surface,
  ]);

  return (
    <Button
      variant="primary"
      withIconStart={<SvgForCurrentBrowserWebExtension size={24} />}
      size="large"
      className={styles.extensionUpsellButton}
      onClick={handleClick}
      data-uxa-log={uxaElementId}
      data-uxa-interactions="shown click"
    >
      {i18n.t("team_onboarding_extension_upsell_button")}
    </Button>
  );
};
